import React, { useEffect, useState } from "react";
import "./Order_details.css";
import Order_id_holder from "./order_id_holder/Order_id_holder";
import Order_details_table from "./order_details_table/Order_details_table";
import Receiver_info_holder from "./receiver_info_holder/Receiver_info_holder";
import Payment_Summary from "./payment_summary/Payment_Summary";
import Common_Back_Header from "../../../../../Common-Component/common_back_header/Common_Back_Header";
import { useParams } from "react-router-dom";
import Payment_Summary_Order from "./payment_summary/Payment_Summary_Order";
import {
  orderGet,
  singleOrderGet,
} from "../../../../../../utils/apis/myAccount/myAccount";
import Rating_Review from "./rating_review/Rating_Review";
import { IDS } from "../../../../../../utils/common";
// import Order_return_Tracking from "../../common-components/order_return_Tracking/Order_return_Tracking";

function Order_details() {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "MY ORDERS", link: "/account", isActive: false },
    { label: "ORDER DETAILS", link: "", isActive: true },
  ];

  const { id } = useParams();

  const [order, setOrder] = useState([]);
  const fetchOrder = async (id) => {
    const res = await singleOrderGet(id);
    if (res?.success) {
      setOrder(res.data);
    }
  };
  useEffect(() => {
    fetchOrder(id);
  }, [id]);
  return (
    <>
      <section className="Order_details">
        <div className="container">
          <Common_Back_Header backNavigation="/my-orders" />

          <div className="row">
            <div className=" col-lg-8 col-md-7">
              <Order_id_holder
              order={order}
                headingText={`Order ID ${order?.invoice_number}`}
              />

              <Order_details_table order={order} />
              {order?.order_status_id === IDS.order_status.Deliverd &&
                order?.product_review === null && <Rating_Review order={order} />}
            </div>

            <div className="col-lg-4 col-md-5">
              <Receiver_info_holder showCancelBtn order={order} />

              <Payment_Summary_Order order={order} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Order_details;
